export default "<p>Practice-user-profile works!</p>\n";